import React, { useState } from 'react';
import styled from 'styled-components';
import * as colors from '../../util/colors';
import { respondTo } from '../../util/breakpoints';
import SubQArrowIcon from '../../assets/utility/icons/subq-arrow-icon.svg';
import { Link } from 'gatsby';

const SubQContainer = styled(Link)`
    display: block;
    cursor:pointer;
    justify-content: center;
    align-items: center;
    gap: 10px;
    height:auto;
    align-self: stretch;
    text-decoration:none;
    transition: background 0.3s linear;
    text-align: center;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px; /* 146.667% */
    letter-spacing: -0.15px;
    padding: 10px 20px;
    color: #FFF;
    position: relative;
    cursor:pointer;
    @media(max-width:767px){
        display: flex;
        align-items: center;
        justify-content: center;
    }
   
    &:after {
        content: '';
        position: absolute;
        background-image: url(${SubQArrowIcon});
        background-repeat: no-repeat;
        background-position: center, left;
        width: 12px;
        height: 12px;
        background-color: #fff;
        border-radius: 50%;
        padding:10px;
        margin-left: 10px;
        @media(max-width:991px){
            right:20px;
        }
        &:hover{
            background: #fff;
        }


    }
    &:hover{
        color: #fff;
        text-decoration:underline;
        &:after {
            background: url(${SubQArrowIcon});
            background-repeat: no-repeat;
            background-color:#fff;
            background-position: center, left;
            animation-duration: 0.3s;
            animation-name: arrowRight-animation;
            animation-fill-mode: both;
        }
    }
    @keyframes arrowRight-animation {
        0% {
            background-position: center 50%, left;
        }

        50% {
            background-position: calc(100% + 20px) center, center;
        }

        50.001% {
            background-position: calc(0% - 20px) center, center;
        }

        100% {
            background-position: center 50%, right;
        }
    }
   
    ${respondTo.md`
        // display: flex;
        padding: 8px 0px;
        height: 36px;
    `}
    
`;

const ExternalLinks = styled.span`
    // Desktop view
      ${respondTo.md`
        
    `}
    // Mobile view
        width:90%
`




const SubQViolator = () => {
    const [gradientPosition, setGradientPosition] = useState({ x: 100, y: 50 });
    const [recursiveRunning, setRecursiveRunning] = useState(false);

    const handleMouseMove = (e) => {
        e.stopPropagation();
        const rect = e.target.getBoundingClientRect();
        const x = Math.round(((e.clientX - rect.left) / rect.width) * 100);
        const y = ((e.clientY - rect.top) / rect.height) * 100;  
    
        if(!recursiveRunning){
        if(x > gradientPosition.x){
            recusrvieCalc(x,y,"increment",gradientPosition.x)
    
        }else{
            recusrvieCalc(x,y,"decrement",gradientPosition.x)
        }
    
        }
    
    };

    function recusrvieCalc(x,y,type,currentX){
 
    if(type == "increment"){    
      setTimeout(()=>{
 
        const changedX = currentX + 1;
        setGradientPosition({
          x: changedX, // Convert mouse position to percentage of the width
          y: y, // Convert mouse position to percentage of the height
        });
        if(x !== currentX){
          setRecursiveRunning(true)
          recusrvieCalc(x,y,"increment",changedX)
        }else{
          setRecursiveRunning(false)
        }
      },0.3)
    }else{
      setTimeout(()=>{
      const changedX = currentX - 1;
      setGradientPosition({
        x: changedX,
        y: y,
      });
      if(x !== currentX){
        setRecursiveRunning(true)
        recusrvieCalc(x,y,"decrement",changedX)
      }else{
        setRecursiveRunning(false)
      }
    },0.3)
    }
  }
   const gradientStyle =  {
    backgroundImage: `radial-gradient(circle at ${gradientPosition.x}% ${gradientPosition.y}%, rgb(90, 0, 143) 0%, rgb(106, 0, 168) 20%, rgb(124, 2, 187) 90%, rgb(90, 0, 143) 100%)`,
    transition:"background 0.3s linear",
  } 
    return (
    <SubQContainer href="https://www.keytrudahcp.com/qlex/" target="_blank" className='subq-container'  onMouseMove={handleMouseMove}  style={gradientStyle}>
        <ExternalLinks> Explore another treatment option in combination with LENVIMA</ExternalLinks>
    </SubQContainer>
)};

export default SubQViolator;